@if (showHeadline) {
  <div class="pageheader">
    <div class="page-title">
      <h1>Charts</h1>
    </div>
  </div>
}
@if (showUpdatingTime) {
  <div class="pull-right">
    <label class="pull-right">@if (isUpdating) {
      <img src="../../images/ajax-loader.gif" alt="Updating..." />
    } Last updated: {{dateTimeService.getFormattedTime(lastUpdate)}}</label>
  </div>
}
@for (chartConfiguration of chartConfigurations; track chartConfiguration) {
  @if (chartConfiguration.Configuration.ChartType == 'Pie') {
    <ep-chart-pie [(size)]="chartConfiguration.Size" [chartConfiguration]="chartConfiguration.Configuration" [colorPalette]="chartConfiguration.Colors"></ep-chart-pie>
  }
  @if (chartConfiguration.Configuration.ChartType == 'Curve') {
    <ep-chart-curve [(size)]="chartConfiguration.Size" [chartConfiguration]="chartConfiguration.Configuration" [colorPalette]="chartConfiguration.Colors"></ep-chart-curve>
  }
  @if (chartConfiguration.Configuration.ChartType == 'Bar') {
    <ep-chart-bar [(size)]="chartConfiguration.Size" [chartConfiguration]="chartConfiguration.Configuration" [colorPalette]="chartConfiguration.Colors"></ep-chart-bar>
  }
  @if (chartConfiguration.Configuration.ChartType == 'Grid') {
    <ep-chart-grid [(size)]="chartConfiguration.Size" [chartConfiguration]="chartConfiguration.Configuration"></ep-chart-grid>
  }
}
